<template>

  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
          :end="dateEnd"
          :start="dateStart"
          @getDates="getDates"
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
          :disabled="loaded"
        />
      </v-col>  
    </v-row>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0" style="padding-bottom: 20px!important">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
            <v-icon>
                mdi-autorenew
            </v-icon>
        </v-btn>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-spacer></v-spacer>
          <v-col cols="7" md="6" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
              :data="dataFilteredForExcel"
              :columns="columnsData"
              :filename="`Keyword Attribution`"
              :sheetname="`${createSheetName}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                class="ml-auto mr-5 rounded-lg pa-0 ma-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
            </vue-excel-xlsx>
            <CustomColumns 
              :currentValue="value"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
            />
          </v-col>
      </v-row>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between nav">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow"
              fab
              small     
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              v-model="selected"
              :headers="selectedHeaders"
              :items="data"
              item-key="id"
              class="elevation-0 mt-2 table-main-container"
              fixed-header
              height="538"
              :loading="loaded"
              :search="search"
              loading-text="Loading... Please wait"
              :page.sync="pagination.page"
              :custom-sort="customSort"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
              @click:row="rowClick"
          >
            <template v-slot:item.search_query="{ item }">
                <span v-if="item.search_query == 0 || item.search_query == null ">-</span>
                <span v-else>{{ item.search_query }}</span>
            </template>
            <template v-slot:header.totalGallons="{ header }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{header.text}}</span>
                </template>
                # of gallons, which this keyword brought inside this campaign
              </v-tooltip>
            </template>
            <template v-slot:header.search_query="{ header }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{header.text}}</span>
                </template>
                 From google analytics
              </v-tooltip>
            </template>
            <template v-slot:item.text="{ item }">
              <div class="d-flex">
                <v-dialog v-if="item.search_term_keyword.length > 0" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" bottom class="flex-grow-0 flex-shrink-0">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <v-card>
                    <v-data-table
                      :headers="[
                                    {text: 'Search Term', value: 'query'},
                                    {text: 'Ad Group', value: 'ad_group'},
                                    {text: 'Day', value: 'day'}
                                   ]"
                      :items="item.search_term_keyword"
                  >
                    <template v-slot:item.day="{ item }">
                      <span>{{ item.day | formatDate }}</span>
                    </template>
                    <template v-slot:header.query="{ header }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{header.text}}</span>
                        </template>
                        From google ads
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  </v-card>
                </v-dialog>
                <span style="text-align: center; width: 100%;">{{ item.text }}</span>
              </div>
            </template>
            <template v-slot:item.campaignName="{ item }">
              <div class="d-flex">

                <v-dialog v-if="item.search_term_campaign.length > 0" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" bottom class="flex-grow-0 flex-shrink-0">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <v-card>
                    <v-data-table
                      :headers="[
                                    {text: 'Search Term', value: 'query'},
                                    {text: 'Ad Group', value: 'ad_group'},
                                    {text: 'Day', value: 'day'}
                                   ]"
                      :items="item.search_term_campaign"
                  >
                    <template v-slot:item.day="{ item }">
                      <span>{{ item.day | formatDate }}</span>
                    </template>
                    <template v-slot:header.query="{ header }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{header.text}}</span>
                        </template>
                        From google ads
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  </v-card>
                </v-dialog>
                <span style="text-align: center; width: 100%;">{{ item.campaignName }}</span>
              </div>
            </template>
            <template v-slot:item.adsType="{ item }">
              <span v-if="item.adsType == 1">Google Ads</span>
              <span v-if="item.adsType == 2">Bing Ads</span>
            </template>
            <template v-slot:item.hubOrderId="{ item }">
              <span v-if="item.hubOrderId == 0 || item.hubOrderId == null ">-</span>
              <span v-else>{{ item.hubOrderId }}</span>
            </template>
            <template v-slot:item.invoiceId="{ item }">
              <span v-if="item.invoiceId == 0 || item.invoiceId == null ">-</span>
              <span v-else>{{ item.invoiceId }}</span>
            </template>
            <template v-slot:item.totalGallons="{ item }">
              <span v-if="item.totalGallons>0">{{ item.totalGallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</span>
              <span v-if="item.totalGallons==0">0</span>
            </template>
            <template v-slot:item.totalPrice="{ item }">
              <span v-if="item.totalPrice > 0 ">$ {{ item.totalPrice | formatPrice }}</span>
              <span v-if="item.totalPrice == 0">0</span>
            </template>
            <template v-slot:item.totalSpent="{ item }">
              <span v-if="item.totalSpent > 0 ">$ {{ item.totalSpent | formatPrice }}</span>
              <span v-if="item.totalSpent == 0">0</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn x-small color="indigo white--text" @click="getHistory(item)">History</v-btn>
            </template>
          </v-data-table>
          <v-dialog
              v-model="dialogHistory"
              max-width="500px"
          >
            <v-card>
              <v-card-title>
                <span>History Changes</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">Date</th>
                      <th class="text-left">Order #</th>
                      <th class="text-left">Mode</th>
                      <th class="text-left">Sale Gallons</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in historyChanged" :key="item.date">
                      <td>{{ item.date }}</td>
                      <td>{{ item.hubOrderId }}</td>
                      <td>{{ item.mode }}</td>
                      <td>{{ item.gallons }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-actions>
                <v-btn
                    color="primary"
                    text
                    @click="dialogHistory = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'

export default {
  components: {
    RangeFilter,
    CustomColumns,
    ExportExcel
  },
  data() {

      let args_filters = this.applyArgsFilters();
      let search_init ='';// args_filters[0];
      let init_stardate = new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10)
      let init_enddate = new Date().toISOString().substr(0, 10);
      if (args_filters){
          search_init = args_filters[0]
          init_stardate = args_filters[1]
          init_enddate = args_filters[2]
      }
    return {
      hideAnything: false,
      selected: [],
      search: search_init,
      headers: [
        {text: 'Google Ads/Bing Ads', value: 'adsType', class: 'black--text'},
        {text: 'Keyword', value: 'text', class: 'black--text'},
        {text: 'Search Query', value: 'search_query', class: 'black--text'},
        {text: 'Match Type', value: 'matchType', class: 'black--text'},
        {text: 'Campaign', value: 'campaignName', class: 'black--text'},
        {text: 'Ad Group', value: 'adGroupName', class: 'black--text'},
        {text: 'Hub Order Id', value: 'hubOrderId', class: 'black--text'},
        {text: 'Invoice Id', value: 'invoiceId', class: 'black--text'},
        {text: 'Sale Date', value: 'saleDate', class: 'black--text'},
          {text: 'Sale Gallons', value: 'movementGallons', class: 'black--text'},
          {text: 'Potentials Gallons', value: 'p_gallons', class: 'black--text'},
        {text: 'Total Gallons K/C', value: 'totalGallons', class: 'black--text'},
        {text: 'Total Revenue K/C', value: 'totalPrice', class: 'black--text'},
        {text: 'Total Spent K/C', value: 'totalSpent', class: 'black--text'},
        {text: 'Lead date', value: 'leadDate', class: 'black--text'},
        {text: 'Max CPC', value: 'leadMaxCpc', class: 'black--text'},
        {text: 'First CPC', value: 'leadFirstCpc', class: 'black--text'},
        {text: 'Top CPC', value: 'leadTopCpc', class: 'black--text'},
        {text: 'First Page CPC', value: 'leadFirstPageCpc', class: 'black--text'},
        {text: 'Rank ', value: 'leadRank', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
      ],
      customHeader: ['adsType', 'text', 'search_query','matchType', 'campaignName', 'adGroupName', 'hubOrderId',
                      'invoiceId', 'saleDate', 'movementGallons', 'totalGallons', 'totalPrice', 'totalSpent',
                      'leadDate','leadMaxCpc','leadFirstCpc','leadTopCpc','leadFirstPageCpc','leadRank','actions'],
      selectedHeaders: [],
      value: [
        {text: 'Google Ads/Bing Ads', value: 'adsType', class: 'black--text'},
        {text: 'Keyword', value: 'text', class: 'black--text'},
        {text: 'Search Query', value: 'search_query', class: 'black--text'},
        {text: 'Match Type', value: 'matchType', class: 'black--text'},
        {text: 'Campaign', value: 'campaignName', class: 'black--text'},
        {text: 'Ad Group', value: 'adGroupName', class: 'black--text'},
        {text: 'Hub Order Id', value: 'hubOrderId', class: 'black--text'},
        {text: 'Invoice Id', value: 'invoiceId', class: 'black--text'},
        {text: 'Sale Date', value: 'saleDate', class: 'black--text'},
        {text: 'Sale Gallons', value: 'movementGallons', class: 'black--text'},
          {text: 'Potentials Gallons', value: 'p_gallons', class: 'black--text'},
          {text: 'Total Gallons K/C', value: 'totalGallons', class: 'black--text'},
        {text: 'Total Revenue K/C', value: 'totalPrice', class: 'black--text'},
        {text: 'Total Spent K/C', value: 'totalSpent', class: 'black--text'},
        {text: 'Lead date', value: 'leadDate', class: 'black--text'},
        {text: 'Max CPC', value: 'leadMaxCpc', class: 'black--text'},
        {text: 'First CPC', value: 'leadFirstCpc', class: 'black--text'},
        {text: 'Top CPC', value: 'leadTopCpc', class: 'black--text'},
        {text: 'First Page CPC', value: 'leadFirstPageCpc', class: 'black--text'},
        {text: 'Rank ', value: 'leadRank', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false}
      ],
      settingsName: 'movementReport',
      data: [],
      dataOrigin: [],
      historyChanged: [],
      dialogHistory: false,
      userName: null,
      loaded: false,
      dateEnd:init_enddate,// new Date().toISOString().substr(0, 10),
      dateStart: init_stardate,/*new Date(
                  Date.UTC(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1)).toISOString().substr(0, 10),*/

      excludePeriod: [],
      defaultPeriod: 4,
      dialogCustomColumns: false,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      pagination: {
        page: 1
      }
    }
  },
  watch: {
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
    hoverOnTable(){
      this.showScrollingArrows()
    },
    data(){
      this.pagination.page = 1
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    this.applyArgsFilters();

    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }
    
    axios
        .get('/username')
        .then(response => (this.userName = response.data))

      let userName = localStorage.getItem('username')
      let settings = this.settingsName
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {
      
        try {

          let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
          this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))
          
          const parsed = JSON.stringify(this.value)
          localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

          this.customHeader = this.value.map(e => e.value)

          this.getHeaderForExcel()
        } catch(e) {
          console.log("")
          }
      }

    this.applyFilters()
    this.showScrollingArrows()
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  computed: {
    dataFilteredForExcel(){
      let data = JSON.parse(JSON.stringify(this.data))
      data.map(e => {
        e.adsType = (e.adsType == 1) ? 'Google Ads' : 'Bing Ads'
      })

      return data
    },
    createSheetName(){
      let name = 'Keyword Movements'
      if (name.length > 30) name = name.substr(0, 30)
      name = name.replace(/(\\|\/)/g, '-')
      return name
    }
  },
  methods: {
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
          if (index[0]=='leadDate' || index[0]== 'saleDate') {
            if (!isDesc[0]) {
                return new Date(b[index]) - new Date(a[index]);
            } else {
                return new Date(a[index]) - new Date(b[index]);
            }
          }
          else {
            if(typeof a[index] === 'number' && typeof b[index] === 'number'){
              if (!isDesc[0]) {
                 return a[index] - b[index];
              }
              else {
                  return b[index] - a[index]
              }
            }else{
              let av = "-"
              if (a[index] !== null && a[index] !== undefined){
                av = a[index]
              }
              let bv = "-"
              if (b[index] !== null && b[index] !== undefined){
                bv = b[index]
              }

              if (!isDesc[0]) {
                 return av.toLowerCase().localeCompare(bv.toLowerCase());
              }
              else {
                  return bv.toLowerCase().localeCompare(av.toLowerCase());
              }
            }
          }
      });
      return items;
    },
    scrollingRight(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows(){
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      //this.pagination.page = 1
      this.applyFilters()
    },
    applyFilters() {
      this.loaded = true
      axios
        .get(`/keyword-movements/${this.dateStart}/${this.dateEnd }`)
        .then(response => {
          this.data = response.data

          this.loaded = false
        })
    },
    getHistory(item) {
      axios
          .get(`/movements/${item.keywordId}/${item.adGroupId}`)
          .then(response => {
            this.historyChanged = response.data
            this.dialogHistory = true
          })
    },
    cleanFilters(){
      this.search = ''
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getCustomData({customHeader, value, selectedHeaders}){
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders

      this.getHeaderForExcel()
    },
    getHeaderForExcel(){
      this.columnsData = this.selectedHeaders.map(e => {
        const obj = {}
          if (e.value !== "actions") {
            obj.label = e.text
            obj.field = e.value
          }
          if (e.value === "totalPrice") {
            obj.label = `${e.text},$`
            obj.field = e.value
          }
          if (e.value === "totalSpent") {
            obj.label = `${e.text},$`
            obj.field = e.value
          }
          return obj
      }).filter(value => Object.keys(value).length !== 0)

      this.columnsData.push({
        label: "Search Term for Keyword",
        field: "search_term_keyword_text"
      })
      this.columnsData.push({
        label: "Search Term for Keyword/Campaign",
        field: "search_term_campaign_text"
      })
    },
      applyArgsFilters(){
          let campName = this.$route.query.campaignName
          let start_date = this.$route.query.startdate
          let end_date = this.$route.query.enddate

          console.log(campName, start_date, end_date);
          if (Boolean(campName)&Boolean(start_date)&Boolean(end_date))
                  return [campName, start_date, end_date]
          return null;

          /*this.dateStart = start_date;
          this.dateEnd = end_date;
          this.search = campName;*/

      },
  }
}
</script>

<style scoped>
  .btn-right-arrow {
    right: 0px;
    top: 70px;
  }
  .btn-left-arrow {
    left: 0px;
    top: 70px;
  }
</style>
